import { Props as FormattedMessageProps } from 'react-intl/src/components/message';

import { AssetType } from '@arrived/models';

export function getAssetTypeFormattedMessage(assetType: AssetType): FormattedMessageProps {
  switch (assetType) {
    case AssetType.STR:
      return { id: 'common.vacation.rental' };
    case AssetType.LTR:
      return { id: 'common.single.family.residential' };
  }
}
